import React from 'react'

export class Footer extends React.Component {
    render(){
        return(
            <div class="footer">
            </div>
        )
    }
}